module.exports = __webpack_public_path__ + "img/logoWellcome.085dc4f3.png";